// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import updatePassiveStoreFromForm from 'redux/modules/pathDetails/thunks/updatePassiveStoreFromForm'
import flipPassiveRepeaters from './flipPassiveRepeaters'

import {
  arraySwap,
  change,
} from 'redux-form'

// this inverts the paths data. Site 1 becomes Site 2 and vice versa
// Passive Repeaters are inverted in a special way to easily translate
// their data back into segment ends for API consumption.
const flipFormValues = sourceForm => (dispatch, getState) => {
  const {
    passiveRepeaters,
    pplPathId,
    pplFlippedFlag,
    segmentIds,
  } = getState().form[sourceForm].values

  // flipping these values is simple
  dispatch(arraySwap(sourceForm, 'sites', 0, 1))
  dispatch(arraySwap(sourceForm, 'regulatory', 0, 1))
  dispatch(arraySwap(sourceForm, 'administration', 0, 1))
  dispatch(arraySwap(sourceForm, 'antennas', 0, 1))
  dispatch(arraySwap(sourceForm, 'radios', 0, 1))
  dispatch(arraySwap(sourceForm, 'losses', 0, 1))
  dispatch(arraySwap(sourceForm, 'frequencyPlans', 0, 1))
  dispatch(arraySwap(sourceForm, 'pathCalculations', 0, 1))

  const flippedPassiveRepeaters = flipPassiveRepeaters(passiveRepeaters)

  dispatch(change(sourceForm, 'passiveRepeaters', flippedPassiveRepeaters))

  // after we've swapped the passive repeater data,
  // tell the passive repeater tooltip to update itself as well.
  dispatch(updatePassiveStoreFromForm(sourceForm))

  // finally, if this path has a PPL, then be sure to say that
  // this new path has been flipped.
  if (pplPathId) {
    dispatch(change(sourceForm, 'pplFlippedFlag', !pplFlippedFlag))
  }

  const swappedSegmentIds = [...segmentIds].reverse()
  dispatch(change(sourceForm, 'segmentIds', swappedSegmentIds))
}

export default flipFormValues
